package com.karyadina.service

import kotlinx.coroutines.flow.StateFlow

interface ModelManagementService {
    val modelStatus: StateFlow<ModelStatus>
    fun downloadModel()
    fun deleteModel()
    fun checkStatus()
    suspend fun importModel(uriStr: String): Boolean
}

enum class ModelStatus {
    MISSING,
    DOWNLOADING,
    READY
}

expect fun provideModelManager(): ModelManagementService
